import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Link, useLocation } from "react-router-dom";

import DownloadApp from '../../component/download-app/downloadApp'
import MHCLocation from "../../component/mhc-location";

import { fetchHomepageData } from "../../actions/get-calls";
import { setVendorReducer } from "../../redux/slice/vendor";
import { useDispatch } from "react-redux";
import { searchTextAPI } from "../../actions/post-call";
import SearchFormWidget from "../../component/search/search-form-widget";
import { APP_SUB_FOLDER, DefaultMetaTag, Domain } from "../../constants/app-constants";
import SpecializedDoctors from "./specializeddoctors";
import OurJourney from "./OurJourney";
import ShowHealthBlogs from "./ShowHealthBlogs";
import Helmet_SEO_META from "../../component/seo_meta";
import { getMetaData } from "../../actions/cms-api-handlers";
// import Counter from "../../component/counter/counter";
import DownloadMyhealthcareApp from "../../component/download-myhealthcare-app/index"
const Home = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    dispatch(setVendorReducer(null));
    const searchType = ['all'];
    const[homePageData, setHomePageData]=useState()
    const [keyword, setKeyword] = useState("");
    const [searchResult, setSearchedResult] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
	useEffect(() => {	
	
        fetchHomepageData().then(function (response) {           
            setHomePageData(response.data.data)	
	})
	.catch(function (err) {
	});  
	}, []);
    //  console.log('homePageData', homePageData)
	useEffect(async () => {
		if (keyword === '' || keyword.length < 3) return false;
		setIsProcessing(true);
		const searchedData = await searchTextAPI(keyword, 'all');

		if (searchedData && searchedData.data && searchedData.data.status === 200) {
			setIsProcessing(false);
			setSearchedResult(searchedData.data);
		}
	}, [keyword]);
        const settings ={
            dots: false,
            infinite: true,
            speed: 2000,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
           autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 4,
                   
                    }
                  },
                  
            ]
            
        }

        ///met tag
        const [getSeoMata, setGetSeoMata]=useState("")
        const pageURL = window.location.origin + window.location.pathname;
        const [SEO_META, setSEO_META]=useState({
            title: DefaultMetaTag.title,
            description: DefaultMetaTag.description,
            keywords:DefaultMetaTag.keyword,
              pageURL: pageURL
        })
    
    
        useEffect(() => {
               const url =    Domain
          getMetaData(url).then(function (response) {
            setGetSeoMata(response.data) 
        })
        .catch(function (err) {
        });  
        }, []);
        useEffect(() => {   
          if(getSeoMata && getSeoMata?.status == true){
                  setSEO_META({
                    title: getSeoMata.data[0].title,
                    description: getSeoMata.data[0].description,
                    keywords: getSeoMata.data[0].keyword,
                    pageURL: pageURL
                })
          }
        }, [getSeoMata])
        return(
          
           <React.Fragment>
            	<DownloadMyhealthcareApp />
	       <Helmet_SEO_META SEO_META={SEO_META} />
               <section className="mhc-home-banner"      style={{ backgroundImage: `url(${homePageData?.topsliderData[0]?.img_url})` }}>
                   <div className="mhc-banner-text">
                       <div className="container">
                      <h1>{homePageData?.topsliderTitle[0]?.main_heading}</h1>
                      <div className="row justify-content-start justify-content-lg-center mt-4 mb-4">
							<div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-2 MHC_location">
								<MHCLocation isNavbar={false} />
							</div>
							<div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-6 col-xxl-6 position-relative mt-4 mt-lg-0">
								<SearchFormWidget
									placeHolder="Search Specialities/Doctors"
									btnDisplay={true}
									searchType={searchType}
									searchResult={searchResult}
									isProcessing={isProcessing}
									setKeyword={setKeyword}
								/>
							</div>
						</div>
                      {/* end row */}
                      <div className="row justify-content-center mt-4 d-none d-lg-flex">
                      <div className="col-lg-12 col-xl-9 col-xxl-8">
                      <div className="bg-white rounded-3">
                          <ul className="list-inline d-flex mb-0">
                             {
                                homePageData?.iconlistData?.map((item, index)=>{
                                    return(
                                        <li className="list-inline-item" key={index+1}>
                                        <Link
                                            className="d-flex align-items-center"
                                            to={item.redirection_url}
                                             //target={(homePageData?.iconlistData[0].redirection_ur) ? "_blank" : ""}
                                            //rel={(moduleIcon && moduleIcon[0].target_blank) ? "noopener noreferrer" : ""}
                                        >
                                            <div className="image-holder">
                                                <img src={item.img_url} alt={item.title} />
                                            </div>											
                                            <span>{item.title}</span>
                                        </Link>
                                    </li>
                                    )
                                })
                             }  
                      
                       
                          </ul>
                      </div>
                          </div>
                          </div>
                 
                       </div> 
                       <div className="row justify-content-center mt-5 d-none d-lg-flex">
                            <div className="col-md-12 call-assistance">
                            <p className="m-0 d-flex justify-content-center align-items-center"><span>{homePageData?.topsliderTitle[0]?.description}</span> <a style={{textDecoration:"none"}} href={`tel:${homePageData?.topsliderTitle[0]?.mobile_number}`}><span className="fs-2 text-primary ms-3">{homePageData?.topsliderTitle[0]?.mobile_number}</span></a></p>
                            </div>
                           </div>
       
                       {/* end container                      */}
                   </div>
               </section>

            

               <section className="our-partner">
                    <div className="container">
                       <div className="row align-items-center">
                           <div className="col-lg-2 d-none d-lg-block">
                               <p className="m-0">Our Partners</p>
                           </div>
                           <div className="col-lg-10">
                           <Slider {...settings}>
                           {
											homePageData?.partnersHospitals?.map((partner) => {
												return <div key={partner._id}><img src={partner.img_url} alt={partner.title ? partner.title : "MyHealthcare Partner Hospital" } /></div>
											})
										}
      
                               </Slider>
                           </div>
                       </div>
                    </div>
               </section>

               <SpecializedDoctors HeaderClassName="text-left text-lg-center" subClassName="text-left text-lg-center mb-0" />
               <section className="mhc-partners-digital-journey">
                  <div className="container">
                      <div className="row justify-content-between">
                          <div className="col-lg-5 col-xl-4 d-none d-lg-block">
                          <img className="mob-img" src={homePageData?.imageUpload[0]?.img_url} alt="MyHealthcare Digitalization" />
                          </div>
                          <div className="col-lg-7 col-xl-7 ">
                      
                              <h1>{homePageData?.digitaljourneyTitle[0]?.main_heading}</h1>
                                {
                                  homePageData?.digitaljourneyData?.map((journey, ikndex)=>{
                                    return(
                                        <div className="content">
                                        <div><img className="icon" src={journey.img_url} alt={journey.title}  /></div>
                                        <div><h4>{journey.title}</h4>
                                        <p dangerouslySetInnerHTML={{ __html: journey.text }}></p>
                                        </div>
                                      </div>
                                    )
                                  })  
                                }
                      
                         
                          </div>
                          {/* end col */}
                      </div>
                  </div>
               </section>

               <OurJourney journeyTittle={homePageData?.OurjourneyTitle[0]} journeyCounter={homePageData?.OurjourneyData} />
			<ShowHealthBlogs HeaderClassName="text-left text-lg-center" subClassName="text-left text-lg-center" />


        	<DownloadApp />
               
           </React.Fragment>
        )

    }


export default Home